<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="user" :rules="rules" :wrapper-col="{span:16}">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.employeeNo')" required>
              <vxe-input v-model="user.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.employeeName')" required>
              <vxe-input v-model="user.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.mnemonicCode')">
              <vxe-input v-model="user.mnemonicCode" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.departmentName')">
              <vxe-select v-model="user.department.id" :options="departments" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.username')">
              <vxe-input v-model="user.empId" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.contactPhone')">
              <vxe-input v-model="user.phoneNumber" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.signatureType')">
              <vxe-select v-model="user.signatureType" :options="signatureTypes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.workstation')">
              <vxe-select v-model="user.workstation.id" :options="workstations" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfCase')">
              <vxe-number-input v-model="user.numberOfCase" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfEach')">
              <vxe-number-input v-model="user.numberOfEach" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfPickingOrder')">
              <vxe-number-input v-model="user.numberOfPickingOrder" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfOrder')">
              <vxe-number-input v-model="user.numberOfOrder" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.role')">
              <vxe-select v-model="roleIds" :options="roles" clearable multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.specialAuthority')">
              <vxe-select v-model="categoryIds" :options="categories" clearable multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.warehouseAuthority')">
              <vxe-select v-model="warehouseIds" :options="warehouses" clearable multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.available')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="user.available"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.pickingFirst')" :label-col="{span:16}" :wrapper-col="{span:8}">
              <vxe-switch v-model="user.pickingFirst"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="24">
            <a-form-model-item :label="$t('business.label.notes')" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
              <vxe-textarea v-model="user.note" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <picker-table v-if="applications.length>0" ref="pickerTable" :applications="applications"/>
    <reviewer-table v-if="applications.length>0" ref="reviewerTable" :applications="applications" :directions="directions" :pickup-modes="pickupModes"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findAll, findOne, save } from '@/api/Api'
import { User } from '@/api/dto/common/User'
import PickerTable from '@/views/basedata/user/PickerTable.vue'
import ReviewerTable from '@/views/basedata/user/ReviewerTable.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'UserDetail',
  components: { PickerTable, ReviewerTable },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      loading: false,
      user: new User(),
      roleIds: [],
      categoryIds: [],
      warehouseIds: [],
      departments: [],
      signatureTypes: [],
      workstations: [],
      roles: [],
      categories: [],
      warehouses: [],
      applications: [],
      pickupModes: [],
      directions: [],
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    findAll('zoneFactory', { available: true, zoneTypes: ['PICKING', 'RECEIVING'], workstation: true }).then(res => {
      if (res.success) {
        this.workstations = getOptions(res.result)
      }
      return findAll('roleFactory', { available: true })
    }).then(res => {
      if (res.success) {
        this.roles = getOptions(res.result)
      }
      return findAll('warehouseFactory', {})
    }).then(res => {
      if (res.success) {
        this.warehouses = getOptions(res.result)
      }
      return getDictionaries('DEPARTMENT')
    }).then(result => {
      this.departments = result
      return getDictionaries('UNLOCK_CATEGORY')
    }).then(result => {
      this.categories = result
      return getDictionaries('PICKUP_MODE')
    }).then(result => {
      this.pickupModes = result
      return getDictionaries('DIRECTION')
    }).then(result => {
      this.directions = result
      return getEnums('Application')
    }).then(result => {
      this.applications = result
      return getEnums('SignatureType')
    }).then(result => {
      this.signatureTypes = result
    })
  },
  methods: {
    back() {
      this.$emit('back')
    },
    build(result) {
      this.user = new User(result)
      this.roleIds = result ? result.roles.map(item => item.id) : []
      this.categoryIds = result ? result.categories.map(item => item.id) : []
      this.warehouseIds = result ? result.warehouses.map(item => item.id) : []
    },
    fetch(id) {
      this.loading = true
      findOne('userFactory', { id: id }).then(res => {
        if (res.success) {
          this.build(res.result)
          this.$refs.pickerTable.fetch(this.user)
          this.$refs.reviewerTable.fetch(this.user)
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.fetch(this.user.id)
    },
    add() {
      this.build()
      this.user.available = true
    },
    save() {
      this.$refs.form.validate(success => {
        if (success) {
          this.$sign({
            reason: '用户管理',
            button: 'save',
            router: this.$route,
            click: () => {
              this.loading = true
              const user = this.user.toJSONObject()
              user.enterprise = this.enterprise
              user.roles = this.roleIds ? this.roleIds.map(item => {
                return { id: item }
              }) : []
              user.categories = this.categoryIds ? this.categoryIds.map(item => {
                return { id: item }
              }) : []
              user.warehouses = this.warehouseIds ? this.warehouseIds.map(item => {
                return { id: item }
              }) : []
              save('userPersister', user).then(res => {
                if (res.success) {
                  this.build(res.result)
                  this.$message.success(this.$t('message.saveSuccess'))
                }
              }).finally(() => this.loading = false)
            }
          })
        }
      })
    },
    enable(row, available) {
      this.fetch(row.id)
      this.user.available = available
      this.save()
    }
  }
}
</script>